// extracted by mini-css-extract-plugin
export default {"publiclayoutContainer":"layoutstyle_publiclayoutContainer__rYIe2","contentBox":"layoutstyle_contentBox__KU+TD","mainHeader":"layoutstyle_mainHeader__o+0I4"};